// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"1afae046","787":"7fb2818a","983":"2b87a759"}[chunkId] + ".chunk.js";
};